module.exports = __webpack_public_path__ + "img/order.15e04640.svg";